import React from 'react';

import { TAnyOfPermissionsHOC } from '../types';

export const withAnyOfPermissions =
  <T,>(permissionsToCheck: Array<string>, ReactComponent: React.FC<T>) =>
  (
    props: React.PropsWithChildren<TAnyOfPermissionsHOC<T>>,
  ): React.ReactElement<TAnyOfPermissionsHOC<T>> => {
    const { user, passThroughComponent } = props;

    // @ts-expect-error type mismatch: string[] !== Authority[]
    if (user.hasAnyOfPermissions(permissionsToCheck)) {
      return <ReactComponent {...props} />;
    }
    return !!passThroughComponent ? passThroughComponent : <></>;
  };
